(function() {
'use strict';

angular.module('TR')
    .directive('lightboxGallery', lightboxGallery);

function lightboxGallery(broker, imageService) {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            close: '&',
            open: '=?',
            images: '=?',
            index: '=?',
            eventMode: '@'
        },
        template: `${'<div>' +
                  '   <div class="modal-overlay"></div>' +
                  '   <div class="lightbox-gallery">' +
                  '       <div class="inner">' +
                  '           <div class="stage">' +
                  '               <div ng-show="busy" class="loader"><preloader class="circular subtle large"></preloader></div>' +
                  '               <div ng-show="!inTransition && images.length > 1" class="counter">{{index + 1}} / {{images.length}}</div>' +
                  '               <a href="#" ng-show="images.length > 1" class="nav prev" ng-click="previous($event)" ng-mouseover="hoverPrev = true" ng-mouseleave="hoverPrev = false"></a>' +
                  '               <a href="#" ng-show="images.length > 1" class="nav next" ng-click="next($event)" ng-mouseover="hoverNext = true" ng-mouseleave="hoverNext = false"></a>' +
                  '           </div>' +
                  '           <a href="#" ng-show="images.length > 1" class="nav-btn prev" ng-class="{hover: hoverPrev}" ng-click="previous($event)"><i class="icon icon-chevron-'}${TRPCONFIG.Rtl ? 'right' : 'left'}"></i></a>` +
                  `           <a href="#" ng-show="images.length > 1" class="nav-btn next" ng-class="{hover: hoverNext}" ng-click="next($event)"><i class="icon icon-chevron-${TRPCONFIG.Rtl ? 'left' : 'right'}"></i></a>` +
                  '           <a href="#" class="close-btn"><i class="icon icon-close"></i></a>' +
                  '       </div>' +
                  '   </div>' +
                  '</div>',

        link(scope, el) {
            const overlay = el.find('.modal-overlay');
            const lightbox = el.find('.lightbox-gallery');
            const inner = el.find('.inner');
            const stage = el.find('.stage');
            const stagePadding = parseInt(stage.css('padding-left')) + parseInt(stage.css('padding-right'));
            let currentImage;

            scope.busy = true;
            scope.inTransition = false;
            scope.index = 0;
            scope.hoverPrev = false;
            scope.hoverNext = false;
            scope.close = scope.eventMode ? () => scope.open = false : scope.close;

            scope.$watch('open', function(v, o) {
                if (v == null || v === o) { return; }
                if (v) {
                    // open

                    // disable window scroll bar
                    $('body').css('overflow', 'hidden');

                    overlay.fadeIn(300, 'swing', function() {
                        lightbox.addClass('open');
                        $(window).resize(); //not particularly thrilled with this

                        // display image at the current index
                        scope.select(scope.index);
                    });
                } else {
                    // close
                    lightbox.removeClass('open');
                    overlay.fadeOut(200, 'swing');

                    // enable window scroll bar
                    $('body').css('overflow', 'scroll');
                }
            });

            // close if background is clicked
            lightbox.on('click.lightboxGallery', function() {
                scope.$apply(scope.close);
            });
            stage.on('click.lightboxGallery', function(e) {
                e.stopPropagation();
            });
            broker.subscribe(
                'lightboxGallery',
                'SHOWGALLERY',
                openImageGallery.bind(scope, imageService)
            );

            // support keyboard commands
            $('html').on('keyup.lightboxGallery', function(e) {
                if (!scope.open) {
                    return;
                }
                if (e.which === 27) {
                    scope.$apply(scope.close); // escape
                }
                if (e.which === 37) {
                    scope.$apply(scope.previous(e)); // left arrow
                }
                if (e.which === 39) {
                    scope.$apply(scope.next(e)); // right arrow
                }
            });

            const getNextIndex = function() {
                return scope.index < scope.images.length - 1 ? parseInt(scope.index) + 1 : 0;
            };

            const getPreviousIndex = function() {
                return scope.index > 0 ? parseInt(scope.index) - 1 : scope.images.length - 1;
            };

            const preloadNext = function() {
                const image = new Image();
                image.src = scope.images[getNextIndex()].src;
            };

            scope.next = function(e) {
                e.preventDefault();
                e.stopPropagation();
                scope.select(getNextIndex());
            };

            scope.previous = function(e) {
                e.preventDefault();
                e.stopPropagation();
                scope.select(getPreviousIndex());
            };

            scope.select = function(index) {
                if (scope.inTransition) { return; }

                scope.inTransition = true;
                scope.index = index;

                // make the current image invisible (we need to retain height or the stage collapses)
                currentImage = stage.find('img').css({ visibility: 'hidden' });
                scope.busy = true;

                const image = new Image();
                image.onload = function() {
                    // user may have closed the lightbox before the image loads
                    if (!scope.open) { return; }

                    // get the image dimensions
                    let width = this.width;
                    let height = this.height;
                    const aspect = width / height;

                    // lock the maximum width of the image so it can't scale up
                    $(image).css({ maxWidth: `${width}px`, maxHeight: `${height}px` });

                    // what is the available display width?
                    const maxWidth = parseInt(inner.width()) - stagePadding;

                    // resize the stage ready to display the image
                    if (width > maxWidth) {
                        // we need to downscale
                        width = maxWidth;
                        height = width / aspect;
                    }

                    // perform the stage resize animation
                    stage.animate({
                        width,
                        height
                    }, {
                        queue: true,
                        duration: 300,
                        easing: 'swing',
                        complete() {
                            currentImage.remove();

                            scope.$apply(function() {
                                scope.busy = false;
                            });

                            // fade in the new image
                            $(image).appendTo(stage).hide().fadeIn(300, 'swing', function() {
                                stage.css({ width: '', height: '' });
                                scope.$apply(function() {
                                    scope.inTransition = false;
                                });
                            });
                        }
                    });
                };

                // preload image
                image.src = scope.images[scope.index].src;
                // preload next image
                preloadNext();
            };

            function openImageGallery(imageService, e) {
                const { estabId, totalImgs } = e.data;
                const w = TRPCONFIG.DeviceSettings.HotelImageMaxWidth;
                const h = TRPCONFIG.DeviceSettings.HotelImageMaxHeight;

                this.index = 0;
                const images = [];
                for (let i = 0, ii = totalImgs; i < ii; i++) {
                    images.push({
                        src: imageService.getImageUrl(estabId, w, h, i, false)
                    });
                }
                this.images = images;
                this.open = true;
            }

            scope.$on('$destroy', function() {
                // unbind jquery event listeners
                $('html').off('keyup.lightboxGallery');
                lightbox.off('click.lightboxGallery');
                stage.off('click.lightboxGallery');
                broker.unsubscribe('lightboxGallery');
            });
        }

    };
}
})();
